 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"layout-config":"layout-config","news-preview":"news-preview","page-article":"page-article","page-articles":"page-articles","page-messages":"page-messages","page-users":"page-users","project-config":"project-config"}[chunkId]||chunkId) + "." + {"chunk-0299ec26":"2fea07b2","chunk-031d7d58":"6c50f49f","chunk-03a51862":"e38b15fc","chunk-13900008":"bc081db1","chunk-2af727c1":"8069ef4a","chunk-2ce0ec19":"996fc5fb","chunk-2d0ac00d":"003a95e1","chunk-2d0bceb2":"fcd948d9","chunk-2d0de973":"cde01930","chunk-2d0deb2d":"2e5249de","chunk-2d0e1fd2":"86df7b46","chunk-2d207ef8":"c1f7769d","chunk-2d20f6ba":"d352ac7f","chunk-2d20f6c9":"68d0b3be","chunk-2d212b36":"c68f9a69","chunk-2d213c50":"dace0ce5","chunk-2d216b57":"f0b4344c","chunk-2d21d13a":"ca0cdda7","chunk-2d22d424":"7ee166ba","chunk-2d22fc96":"69bfd927","chunk-384465a6":"dbaba029","chunk-3d2164dd":"67eadb53","chunk-40e78c88":"b50b2c95","chunk-43e649b4":"42cc8b0a","chunk-4e33d1b4":"cce19a09","chunk-5ac3269b":"67e3a51a","chunk-5d69ba90":"fce62be5","chunk-631d6ada":"68ef05f4","chunk-63748564":"4431ebe8","chunk-6cc0e219":"39477b70","chunk-6f786f80":"becd0fed","chunk-744da53a":"dc5affdf","chunk-77ccd2ae":"dc82bc88","chunk-78b8ba8e":"c978af76","chunk-94a633b4":"c45619f0","chunk-b92a0cda":"1f63a5c4","chunk-2f533a00":"b39f9122","chunk-56348508":"c6f24578","chunk-7aa866f6":"51573425","chunk-c7869d48":"8ec06e88","chunk-cb9304aa":"6f8e69a1","chunk-fe633e0e":"98ccdf9a","layout-config":"c1d23bc8","news-preview":"b71a5582","page-article":"eabbd398","page-articles":"1b940513","page-messages":"d1d906d0","page-users":"c4df4815","project-config":"4ba1db69"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-03a51862":1,"chunk-13900008":1,"chunk-2ce0ec19":1,"chunk-40e78c88":1,"chunk-43e649b4":1,"chunk-4e33d1b4":1,"chunk-5ac3269b":1,"chunk-63748564":1,"chunk-6cc0e219":1,"chunk-744da53a":1,"chunk-77ccd2ae":1,"chunk-94a633b4":1,"chunk-fe633e0e":1,"news-preview":1,"page-articles":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"layout-config":"layout-config","news-preview":"news-preview","page-article":"page-article","page-articles":"page-articles","page-messages":"page-messages","page-users":"page-users","project-config":"project-config"}[chunkId]||chunkId) + "." + {"chunk-0299ec26":"31d6cfe0","chunk-031d7d58":"31d6cfe0","chunk-03a51862":"11dfa64b","chunk-13900008":"43c8d286","chunk-2af727c1":"31d6cfe0","chunk-2ce0ec19":"bc27d20a","chunk-2d0ac00d":"31d6cfe0","chunk-2d0bceb2":"31d6cfe0","chunk-2d0de973":"31d6cfe0","chunk-2d0deb2d":"31d6cfe0","chunk-2d0e1fd2":"31d6cfe0","chunk-2d207ef8":"31d6cfe0","chunk-2d20f6ba":"31d6cfe0","chunk-2d20f6c9":"31d6cfe0","chunk-2d212b36":"31d6cfe0","chunk-2d213c50":"31d6cfe0","chunk-2d216b57":"31d6cfe0","chunk-2d21d13a":"31d6cfe0","chunk-2d22d424":"31d6cfe0","chunk-2d22fc96":"31d6cfe0","chunk-384465a6":"31d6cfe0","chunk-3d2164dd":"31d6cfe0","chunk-40e78c88":"9f88dd77","chunk-43e649b4":"e4e0b119","chunk-4e33d1b4":"92ab6be4","chunk-5ac3269b":"81e20f77","chunk-5d69ba90":"31d6cfe0","chunk-631d6ada":"31d6cfe0","chunk-63748564":"c977b0b4","chunk-6cc0e219":"11dfa64b","chunk-6f786f80":"31d6cfe0","chunk-744da53a":"c6ac21ad","chunk-77ccd2ae":"7b2ee7d2","chunk-78b8ba8e":"31d6cfe0","chunk-94a633b4":"cea85283","chunk-b92a0cda":"31d6cfe0","chunk-2f533a00":"31d6cfe0","chunk-56348508":"31d6cfe0","chunk-7aa866f6":"31d6cfe0","chunk-c7869d48":"31d6cfe0","chunk-cb9304aa":"31d6cfe0","chunk-fe633e0e":"238d0350","layout-config":"31d6cfe0","news-preview":"e2622cba","page-article":"31d6cfe0","page-articles":"05c86911","page-messages":"31d6cfe0","page-users":"31d6cfe0","project-config":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
